<template>
  <div>
    <v-container>
      <v-card>
        <v-card-title class="green accent-3">Akta Pendirian
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-text-field
                type="text"
                outlined
                label="Nomor Akta"
                v-model="aktaANo"
                readonly
              />  
              <v-text-field
                :value="getDateFormattedDatefns(aktaATgl)"
                label="Tanggal Akta"
                readonly
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                type="text"
                outlined
                label="Notaris"
                v-model="aktaANotaris"
                readonly
              />  
              <v-text-field
                type="text"
                outlined
                readonly
                label="Dokumen Akta"
                v-model="aktaADoc"
                append-icon="get_app"
                @click:append="getLinkDownload(aktaADoc)"
              />  
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card>
        <v-card-title dark class="green accent-3">Akta Perubahan Terakhir
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-text-field
                type="text"
                outlined
                label="Nomor Akta"
                v-model="aktaUNo"
                readonly
              />  
              <v-text-field
                :value="getDateFormattedDatefns(aktaUTgl)"
                label="Tanggal Akta"
                readonly
                outlined
              ></v-text-field>              
            </v-col>
            <v-col cols="6">
              <v-text-field
                type="text"
                outlined
                label="Notaris"
                v-model="aktaUNotaris"
                readonly
              />  
              <v-text-field
                type="text"
                outlined
                readonly
                label="Dokumen Akta"
                v-model="aktaUDoc"
                append-icon="get_app"
                @click:append="getLinkDownload(aktaUDoc)"
              />  
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

    <v-row>
      <v-col cols="12">
        <template v-if="isVerifikasi">
          <v-chip dark color="green">
            <v-avatar left>
              <v-icon>mdi-checkbox-marked-circle</v-icon>
            </v-avatar>Sudah Verifikasi
          </v-chip>
        </template>
        <template v-else>
          <v-card>
            <v-textarea v-model="remark" label="Remark: Catatan kekurangan kelengkapan data" outlined ></v-textarea>
            <v-card-actions>
              <v-btn color="success" @click="verifikasiClick()">Verifikasi</v-btn>
              <v-btn color="error" @click="dataKurangLengkapClick()">Data Kurang Lengkap</v-btn>
              <v-label v-if="remarkSubmitted"><span class="blue--text">Catatan kekurangan kelengkapan data diperbarui</span></v-label>
            </v-card-actions>
          </v-card>
        </template>
      </v-col>
    </v-row>

    </v-container>

    <v-dialog v-model="submitting" persistent max-width="300px">
        <v-card dark>
            <v-card-title>Sedang diproses</v-card-title>
            <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
        </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from 'axios'
const apiUrl = process.env.VUE_APP_ROOT_API
import { format, parseISO } from 'date-fns'

export default {
  data: function() {
    return {
      aktaId: -999,
      aktaANo: '',
      aktaATgl: null,
      aktaANotaris: '',
      aktaADoc: null,
      aktaAMenu: false,
      aktaUNo: '',
      aktaUTgl: null,
      aktaUNotaris: '',
      aktaUDoc: null,
      aktaUMenu: false,
      remark: '',
      remarkSubmitted: false,

      submitting: false,
    }
  },
  watch: {
    Id: function(newVal, oldVal) {
      console.log(`oldVal = ${oldVal}, newVal = ${newVal}`)
      this.aktaId = -999
      this.aktaANo = ''
      this.aktaATgl = ''
      this.aktaANotaris = ''
      this.aktaADoc = ''
      this.aktaUNo = ''
      this.aktaUTgl = ''
      this.aktaUNotaris = ''
      this.aktaUDoc = ''
      this.getVendorData(newVal)
      this.getRemark('akta');
    }
  },
  computed: {
    isVerifikasi: function() {
      return this.$store.getters['reg/statusAkta'] === 'A'
    },
    Id: function() {
      return this.$store.getters['ven/venId']
    }
  },
  mounted: function() {
    this.getVendorData()
    this.getRemark('akta')
  },
  methods: {
    async getRemark(jenis) {
      this.remark = "";
      this.remarkSubmitted = false;

      await axios.get(`${apiUrl}/vendor/remark/jenis/${jenis}/id/${this.Id}`)
      .then((response) => {
        console.log(response)
        this.remark = response.data
      })
    },
    verifikasiClick: async function() {
      this.submitting = true;

      await axios.post(apiUrl+'/vendor/perusahaan/status', { jenisStatus: 'akta', vendorId: this.Id, val: 'A'})
      .then((response) => {
        console.log(response)
        this.$store.commit('reg/setStatusAkta', 'A')
      })
      .finally( () => {
        this.submitting = false;
      })
    },
    dataKurangLengkapClick: async function() {
      const payload = {
        jenisStatus: "akta",
        value: this.remark
      };

      this.submitting = true;

      await axios.put(apiUrl + "/vendor/perusahaan/remark/" + this.Id, payload)
      .then( (response) => {
        console.log(response);
      })
      .catch( (error) => {
        console.error(error);
      })
      .finally( () => {
        this.submitting = false;
      });

      this.remarkSubmitted = true;
    },
    getVendorData: async function() {
      await axios.get(`${apiUrl}/vendor/register3/akta/${this.Id}`)
      .then((response) => {  
        if (response.data.data.aktaId !== -999) {
          this.aktaId = response.data.data.aktaId
          this.aktaANo = response.data.data.aktaANo
          this.aktaATgl = response.data.data.aktaATgl
          this.aktaANotaris = response.data.data.aktaANotaris
          this.aktaADoc = response.data.data.aktaADoc
          this.aktaUNo = response.data.data.aktaUNo
          this.aktaUTgl = response.data.data.aktaUTgl
          this.aktaUNotaris = response.data.data.aktaUNotaris
          this.aktaUDoc = response.data.data.aktaUDoc
        }
      })
    },
    getDateFormattedDatefns: function(date) {
      return date ? format(parseISO(date), "dd MMM yyyy") : ''
    },
    getLinkDownload: function(dok) {
      /*
      axios.get(`${apiUrl}/${dok}`, { responseType: 'blob' })
      .then(response => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = dok
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
      */
      window.open(`${apiUrl}/${dok}`, '_blank');
    },
  }
}
</script>

<style>

</style>